import { useEffect, useState } from 'react'
import { X } from 'lucide-react'
import { API_BASE_URL } from '@/services/apiClient'

type Ann = { id: string; title: string; body: string; createdAt: string }

const DISMISSED_KEY = 'neteasyftx_dismissed_announcements'

export function PublicAnnouncementsBanner() {
  const [list, setList] = useState<Ann[]>([])
  const [dismissed, setDismissed] = useState<Set<string>>(() => {
    try {
      const raw = localStorage.getItem(DISMISSED_KEY)
      return new Set(raw ? JSON.parse(raw) : [])
    } catch {
      return new Set()
    }
  })

  useEffect(() => {
    let cancelled = false
    void (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/public/announcements`)
        if (!res.ok) return
        const data = (await res.json()) as Ann[]
        if (!cancelled) setList(data)
      } catch {
        /* ignore */
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const visible = list.filter((a) => !dismissed.has(a.id))
  if (visible.length === 0) return null

  const dismiss = (id: string) => {
    const next = new Set(dismissed).add(id)
    setDismissed(next)
    try {
      localStorage.setItem(DISMISSED_KEY, JSON.stringify([...next]))
    } catch {
      /* ignore */
    }
  }

  const a = visible[0]

  return (
    <div className="bg-blue-600 text-white text-sm py-2 px-4 flex items-start gap-3 border-b border-blue-700">
      <div className="flex-1 min-w-0">
        <strong className="block">{a.title}</strong>
        <p className="text-blue-100 mt-0.5 whitespace-pre-wrap break-words">{a.body}</p>
      </div>
      <button
        type="button"
        onClick={() => dismiss(a.id)}
        className="p-1 rounded hover:bg-blue-500 shrink-0"
        aria-label="Cerrar aviso"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
